import Page from "components/Page"
import SectionHeaderCell from "components/UI/SectionHeaderCell"
import WhatsUpQuickLinksList from "components/WhatsUp/QuickLinksList"
import SectionFeaturedPosts from "components/Section/FeaturedPosts"
import WhatsUpPostsList from "components/WhatsUp/PostList"
import PropTypes from "prop-types"
import { Endpoint, ApiPath } from "lib/endpoint"
import { DateTime } from "luxon"
import { useRouter } from "next/router"
import { OGP } from "components/Meta"
import absoluteUrl from "next-absolute-url"

const WhatsUp = (props) => {
  const lastModified = props.items[0]
    ? `Last Updated: ${DateTime.fromSQL(props.items[0].updated_at, {
        zone: "Asia/Tokyo",
      }).toFormat("LLL dd yyyy")}`
    : ""

  return (
    <>
      <OGP meta={props.meta} />
      <Page showModalMobile={false}>
        <div className="flex flex-col items-stretch space-y-wrapper py-wrapper lg:box-x-wrapper">
          <div className="relative flex flex-col items-stretch lg:items-start space-y-wrapper lg:flex-row lg:space-y-0 lg:space-x-wrapper">
            <div className="flex flex-col space-y-wrapper lg:w-1/3 lg:space-y-section lg:sticky lg:self-start lg:top-30">
              <SectionHeaderCell
                titleLabel="What’s up"
                subLabel={lastModified}
                className="box-x-wrapper"
              />

              <div className="space-y-4">
                <WhatsUpQuickLinksList
                  wrapperClassName="flex overflow-x-scroll scrollbar-hidden md:overflow-x-auto"
                  className="inline-block box-x-wrapper"
                />
                {!props.featured == 0 && (
                  <SectionFeaturedPosts items={props.featured} />
                )}
              </div>
            </div>
            <WhatsUpPostsList
              className="flex flex-col space-y-wrapper box-x-wrapper lg:w-2/3 lg:space-y-section xl:space-y-0 xl:grid xl:grid-cols-2 xl:gap-x-section xl:gap-y-section"
              items={props.items}
            />
          </div>
        </div>
      </Page>
    </>
  )
}

export const getServerSideProps = async ({ req }) => {
  const { protocol, host } = absoluteUrl(req, "localhost:3000")
  const res1 = await fetch(`${Endpoint}${ApiPath}/whats-up`)
  const items = await res1.json()
  const res2 = await fetch(`${Endpoint}${ApiPath}/whats-up/featured`)
  const featured = await res2.json()

  const meta = {
    title: "What's Up | NobodySurf",
    description:
      "Check out the list of surf videos and films featured on NobodySurf.",
    image: "https://cdn.nobodysurf.com/com/img/NobodySurf_Cover_w1800.png",
    url: `${protocol}//${host}${req.originalUrl}`,
  }

  return {
    props: {
      items: items,
      featured: featured,
      meta: meta,
    },
  }
}

export default WhatsUp

WhatsUp.propTypes = {
  featured: PropTypes.array,
}
